/* eslint-disable no-unused-vars */
import { combineReducers } from 'redux';
import authReducer from './authorization';
import auditLogsReducer from './auditLogs';
import jobsReducer from './jobs';
import alarmsReducer from './alarms';
import partReducer from './parts';
import companyReducer from './companies';
import sellerReducer from './sellers';
import userReducer from './users';
import assetDataReducer from './assetData';
import assetsReducer from './assets';
import ordersReducer from './orders';
import ticketsReducer from './tickets';
import quotesReducer from './quotes';
import snackbarReducer from './snackbar';
import menuReducer from './menu';
import searchBoxReducer from './searchBox';
import dataLoadingReducer from './dataLoading';
import epicorCustomerReducer from './epicor/epicorCustomers';
import epicorPartReducer from './epicor/epicorParts';
import epicorPriceListsReducer from './epicor/epicorPriceLists';
import epicorSaleOrdersReducer from './epicor/epicorSaleOrders';
import epicorWorkForceReducer from './epicor/epicorWorkForce';
import epicorBinsReducer from './epicor/epicorBins';
import epicorTrucksReducer from './epicor/epicorTrucks';
import epicorSyncMobileDevicesReducer from './epicor/epicorSyncMobileDevices';
import epicorSendBinRemindersReducer from './epicor/epicorSendBinReminders';
import epicorSyncSignatureHarvestReducer from './epicor/epicorSyncSignatureHarvest';
import epicorReleasesReducer from './epicor/epicorReleases';
import epicorOrderDetailsReducer from './epicor/epicorOrderDetails';
import transactionHistoryReducer from './transactionHistory';
import alarmHistoryReducer from './alarmHistory';
import wellsReducer from './wells';
import marketplaceTransactionsReducer from './marketplaceTransactions';
import rigsReducer from './rigs';
import assetTypesReducer from './assetTypes';
import enverusWellsReducer from './enverus/wells';
import checkInsReducer from './checkins';
import actuatorReducer from './actuatorReport';
import marketplaceReducer from './marketplace';
import wellsSurveyReducer from './wellsSurvey';
import wellsDrillStringReducer from './wellsDrillString';
import wellsDrillFluidReducer from './wellsDrillFluid';
import wellsGeometryReducer from './wellsGeometry';
import hydraulicsReducer from './hydraulics';
import marketplaceLogsReducer from './marketplaceLogs';
import checkInsDrillReducer from './checkInsDrill';
import wellsWindowReducer from './wellsWindow';
import dbwVsTargetReducer from './dbwVsTarget';
import spendReducer from './spend';
import favoritePartsReducer from './favoriteParts';
import mpdCustomerReducer from './customers';
import hydraulicsLogsReducer from './hydraulicsLogs';
import { USER_TYPE } from '../../utils/constants';
import userBugsReducer from './userBugs';
import hydraulicsParameterAnalysisReducer from './hydraulicsParamterAnalysis';
import strippingReducer from './stripping';
import firebasePayReducer from './firebasePay';
import firebaseDrillReducer from './firebaseDrill';
import observationReducer from './observation';
import wellsPWDReducer from './wellsPWD';
import hydraulicsDisplacementReducer from './hydraulicsDisplacement';
import hydraulicsRolloverReducer from './hydraulicsRollover';
import wellboreVolumeReducer from './wellboreVolume';
import assetMapReducer from './assetMap';
import hydraulicsLandingReducer from './hydraulicsLanding';
import fieldPicturesDrillReducer from './fieldPicturesDrill';
import realtimeCollectionsReducer from './realtimeCollections';
import payTargetsReducer from './payTargets';
import payTargetsQuestionsReducer from './payTargetsQuestions';
import targetAnswersReducer from './targetAnswers';
import wellboreImportReducer from './wellboreImport';
import permissionsReducer from './permissions';

const userTypeReducers = {
  [USER_TYPE.PREMIUM_ADMIN]: {
    jobs: jobsReducer,
    alarms: alarmsReducer,
    parts: partReducer,
    companies: companyReducer,
    sellers: sellerReducer,
    users: userReducer,
    assetData: assetDataReducer,
    assets: assetsReducer,
    orders: ordersReducer,
    tickets: ticketsReducer,
    quotes: quotesReducer,
    epicorCustomers: epicorCustomerReducer,
    epicorParts: epicorPartReducer,
    epicorPriceLists: epicorPriceListsReducer,
    epicorSaleOrders: epicorSaleOrdersReducer,
    epicorWorkForce: epicorWorkForceReducer,
    epicorBins: epicorBinsReducer,
    epicorTrucks: epicorTrucksReducer,
    epicorReleases: epicorReleasesReducer,
    epicorOrderDetails: epicorOrderDetailsReducer,
    epicorSyncMobileDevices: epicorSyncMobileDevicesReducer,
    epicorSendBinReminders: epicorSendBinRemindersReducer,
    auditLogs: auditLogsReducer,
    hydraulicsLogs: hydraulicsLogsReducer,
    transactionHistory: transactionHistoryReducer,
    alarmHistory: alarmHistoryReducer,
    wells: wellsReducer,
    marketplaceTransactions: marketplaceTransactionsReducer,
    wellsSurvey: wellsSurveyReducer,
    rigs: rigsReducer,
    assetTypes: assetTypesReducer,
    enverusWells: enverusWellsReducer,
    checkIns: checkInsReducer,
    actuatorReport: actuatorReducer,
    wellsDrillString: wellsDrillStringReducer,
    wellsDrillFluid: wellsDrillFluidReducer,
    wellsGeometry: wellsGeometryReducer,
    wellsWindow: wellsWindowReducer,
    hydraulics: hydraulicsReducer,
    marketplaceLogs: marketplaceLogsReducer,
    checkInsDrill: checkInsDrillReducer,
    dbwVsTarget: dbwVsTargetReducer,
    spend: spendReducer,
    favoritePart: favoritePartsReducer,
    mpdCustomer: mpdCustomerReducer,
    hydraulicsParameterAnalysis: hydraulicsParameterAnalysisReducer,
    stripping: strippingReducer,
    observation: observationReducer,
    wellsPWD: wellsPWDReducer,
    firebasePay: firebasePayReducer,
    firebaseDrill: firebaseDrillReducer,
    displacement: hydraulicsDisplacementReducer,
    rollover: hydraulicsRolloverReducer,
    wellboreVolume: wellboreVolumeReducer,
    assetsMap: assetMapReducer,
    fieldPicturesDrill: fieldPicturesDrillReducer,
    realtimeCollections: realtimeCollectionsReducer,
    payTargets: payTargetsReducer,
    epicorSyncSignatureHarvest: epicorSyncSignatureHarvestReducer,
    payTargetsQuestions: payTargetsQuestionsReducer,
    targetAnswers: targetAnswersReducer,
    wellboreMudProfiles: wellboreImportReducer,
    permissions: permissionsReducer
  },
  [USER_TYPE.CUSTOMER_USER]: {
    orders: ordersReducer,
    quotes: quotesReducer,
    companies: companyReducer,
    parts: partReducer,
    spend: spendReducer,
    users: userReducer
  },
  [USER_TYPE.CUSTOMER_RIG]: {
    orders: ordersReducer,
    quotes: quotesReducer,
    companies: companyReducer,
    parts: partReducer,
    spend: spendReducer,
    users: userReducer
  },
  [USER_TYPE.SELLER_MARKETPLACE_ADMIN]: {
    orders: ordersReducer,
    quotes: quotesReducer,
    companies: companyReducer,
    parts: partReducer,
    spend: spendReducer,
    users: userReducer
  },
  [USER_TYPE.CUSTOMER_MANAGER]: {
    orders: ordersReducer,
    quotes: quotesReducer,
    companies: companyReducer,
    parts: partReducer,
    spend: spendReducer,
    users: userReducer,
    favoritePart: favoritePartsReducer
  },
  [USER_TYPE.CUSTOMER_ADMIN]: {
    orders: ordersReducer,
    quotes: quotesReducer,
    companies: companyReducer,
    parts: partReducer,
    spend: spendReducer,
    users: userReducer,
    favoritePart: favoritePartsReducer
  },
  [USER_TYPE.PREMIUM_FIELD_TICKETING_ADMIN]: {
    tickets: ticketsReducer,
    epicorCustomers: epicorCustomerReducer,
    epicorParts: epicorPartReducer,
    epicorPriceLists: epicorPriceListsReducer,
    epicorSaleOrders: epicorSaleOrdersReducer,
    epicorWorkForce: epicorWorkForceReducer,
    epicorBins: epicorBinsReducer,
    epicorTrucks: epicorTrucksReducer,
    epicorReleases: epicorReleasesReducer,
    epicorOrderDetails: epicorOrderDetailsReducer,
    epicorSyncMobileDevices: epicorSyncMobileDevicesReducer,
    epicorSendBinReminders: epicorSendBinRemindersReducer,
    rigs: rigsReducer,
    checkIns: checkInsReducer,
    dbwVsTarget: dbwVsTargetReducer,
    transactionHistory: transactionHistoryReducer,
    users: userReducer,
    companies: companyReducer,
    epicorSyncSignatureHarvest: epicorSyncSignatureHarvestReducer,
    payTargetsQuestions: payTargetsQuestionsReducer,
    targetAnswers: targetAnswersReducer,
    payTargets: payTargetsReducer,
  },
  [USER_TYPE.PREMIUM_FIELD_TICKETING_MANAGER]: {
    tickets: ticketsReducer,
    epicorCustomers: epicorCustomerReducer,
    epicorParts: epicorPartReducer,
    epicorPriceLists: epicorPriceListsReducer,
    epicorSaleOrders: epicorSaleOrdersReducer,
    epicorWorkForce: epicorWorkForceReducer,
    epicorBins: epicorBinsReducer,
    epicorTrucks: epicorTrucksReducer,
    epicorReleases: epicorReleasesReducer,
    epicorOrderDetails: epicorOrderDetailsReducer,
    epicorSyncMobileDevices: epicorSyncMobileDevicesReducer,
    epicorSendBinReminders: epicorSendBinRemindersReducer,
    rigs: rigsReducer,
    checkIns: checkInsReducer,
    dbwVsTarget: dbwVsTargetReducer,
    transactionHistory: transactionHistoryReducer,
    epicorSyncSignatureHarvest: epicorSyncSignatureHarvestReducer
  },
  [USER_TYPE.PREMIUM_FIELD_TICKETING_USER]: {
    tickets: ticketsReducer,
    epicorBins: epicorBinsReducer,
    epicorTrucks: epicorTrucksReducer,
    epicorWorkForce: epicorWorkForceReducer,
    epicorReleases: epicorReleasesReducer,
    epicorOrderDetails: epicorOrderDetailsReducer,
    rigs: rigsReducer,
    dbwVsTarget: dbwVsTargetReducer,
    checkIns: checkInsReducer,
    transactionHistory: transactionHistoryReducer
  },
  [USER_TYPE.PREMIUM_MARKETPLACE_ADMIN]: {
    orders: ordersReducer,
    quotes: quotesReducer,
    companies: companyReducer,
    parts: partReducer,
    spend: spendReducer,
    sellers: sellerReducer,
    users: userReducer,
    marketplaceTransactions: marketplaceTransactionsReducer,
  },
  [USER_TYPE.MPD_CUSTOMER_USER]: {
    jobs: jobsReducer,
    assetData: assetDataReducer,
    actuatorReport: actuatorReducer,
    enverusWells: enverusWellsReducer,
    wells: wellsReducer,
    rigs: rigsReducer,
    wellsSurvey: wellsSurveyReducer,
    wellsDrillString: wellsDrillStringReducer,
    wellsDrillFluid: wellsDrillFluidReducer,
    wellsGeometry: wellsGeometryReducer,
    wellsWindow: wellsWindowReducer,
    hydraulics: hydraulicsReducer,
    hydraulicsParameterAnalysis: hydraulicsParameterAnalysisReducer,
    stripping: strippingReducer,
    observation: observationReducer,
    wellsPWD: wellsPWDReducer,
    displacement: hydraulicsDisplacementReducer,
    rollover: hydraulicsRolloverReducer,
    wellboreVolume: wellboreVolumeReducer,
    wellboreMudProfiles: wellboreImportReducer
  },
  [USER_TYPE.PREMIUM_REALTIME_MPD_ADMIN]: {
    users: userReducer,
    companies: companyReducer,
    mpdCustomer: mpdCustomerReducer,
    alarms: alarmsReducer,
    jobs: jobsReducer,
    assetData: assetDataReducer,
    assets: assetsReducer,
    actuatorReport: actuatorReducer,
    enverusWells: enverusWellsReducer,
    wells: wellsReducer,
    rigs: rigsReducer,
    wellsSurvey: wellsSurveyReducer,
    wellsDrillString: wellsDrillStringReducer,
    wellsDrillFluid: wellsDrillFluidReducer,
    wellsGeometry: wellsGeometryReducer,
    wellsWindow: wellsWindowReducer,
    hydraulics: hydraulicsReducer,
    checkInsDrill: checkInsDrillReducer,
    hydraulicsLogs: hydraulicsLogsReducer,
    hydraulicsParameterAnalysis: hydraulicsParameterAnalysisReducer,
    stripping: strippingReducer,
    observation: observationReducer,
    wellsPWD: wellsPWDReducer,
    alarmHistory: alarmHistoryReducer,
    displacement: hydraulicsDisplacementReducer,
    rollover: hydraulicsRolloverReducer,
    wellboreVolume: wellboreVolumeReducer,
    assetsMap: assetMapReducer,
    assetTypes: assetTypesReducer,
    wellboreMudProfiles: wellboreImportReducer,
    permissions: permissionsReducer,
    transactionHistory: transactionHistoryReducer,
    checkIns: checkInsReducer,
    epicorBins: epicorBinsReducer,
    epicorTrucks: epicorTrucksReducer,
    epicorWorkForce: epicorWorkForceReducer,
  },
  [USER_TYPE.PREMIUM_MPD_USER]: {
    jobs: jobsReducer,
    assetData: assetDataReducer,
    assets: assetsReducer,
    actuatorReport: actuatorReducer,
    enverusWells: enverusWellsReducer,
    wells: wellsReducer,
    rigs: rigsReducer,
    wellsSurvey: wellsSurveyReducer,
    wellsDrillString: wellsDrillStringReducer,
    wellsDrillFluid: wellsDrillFluidReducer,
    wellsGeometry: wellsGeometryReducer,
    wellsWindow: wellsWindowReducer,
    hydraulics: hydraulicsReducer,
    checkInsDrill: checkInsDrillReducer,
    hydraulicsParameterAnalysis: hydraulicsParameterAnalysisReducer,
    stripping: strippingReducer,
    observation: observationReducer,
    wellsPWD: wellsPWDReducer,
    displacement: hydraulicsDisplacementReducer,
    rollover: hydraulicsRolloverReducer,
    wellboreVolume: wellboreVolumeReducer,
    wellboreMudProfiles: wellboreImportReducer,
    transactionHistory: transactionHistoryReducer,
    checkIns: checkInsReducer,
    epicorBins: epicorBinsReducer,
    epicorTrucks: epicorTrucksReducer,
    epicorWorkForce: epicorWorkForceReducer,
  },
  [USER_TYPE.PREMIUM_MPD_MANAGER]: {
    jobs: jobsReducer,
    assetData: assetDataReducer,
    assets: assetsReducer,
    actuatorReport: actuatorReducer,
    enverusWells: enverusWellsReducer,
    wells: wellsReducer,
    rigs: rigsReducer,
    wellsSurvey: wellsSurveyReducer,
    wellsDrillString: wellsDrillStringReducer,
    wellsDrillFluid: wellsDrillFluidReducer,
    wellsGeometry: wellsGeometryReducer,
    wellsWindow: wellsWindowReducer,
    hydraulics: hydraulicsReducer,
    checkInsDrill: checkInsDrillReducer,
    hydraulicsParameterAnalysis: hydraulicsParameterAnalysisReducer,
    stripping: strippingReducer,
    observation: observationReducer,
    wellsPWD: wellsPWDReducer,
    displacement: hydraulicsDisplacementReducer,
    rollover: hydraulicsRolloverReducer,
    wellboreVolume: wellboreVolumeReducer,
    wellboreMudProfiles: wellboreImportReducer,
    permissions: permissionsReducer,
    transactionHistory: transactionHistoryReducer,
    checkIns: checkInsReducer,
    epicorBins: epicorBinsReducer,
    epicorTrucks: epicorTrucksReducer,
    epicorWorkForce: epicorWorkForceReducer,
  },
};

const getAvailableReducers = (userType, accessLevels) => {
  const commonReducers = {
    currentUser: authReducer,
    snackbar: snackbarReducer,
    dataLoading: dataLoadingReducer,
    menu: menuReducer,
    searchBox: searchBoxReducer,
    userBugs: userBugsReducer,
    marketplace: marketplaceReducer,
    wells: wellsReducer,
    hydraulicsLanding: hydraulicsLandingReducer
    // add other common reducers that should always be available
  };

  const combinedUserReducers = {
    ...(userTypeReducers[userType] || {})
  };

  if (userType === USER_TYPE.PREMIUM_SELECT_ADMIN) {
    accessLevels.forEach(level => {
      const levelReducers = userTypeReducers[level] || {};
      Object.entries(levelReducers).forEach(([key, reducer]) => {
        if (!combinedUserReducers[key]) {
          combinedUserReducers[key] = reducer;
        }
      });
    });
  }

  return {
    ...commonReducers,
    ...combinedUserReducers,
  };
};

const rootReducer = (state, action) => {
  const userType = state?.currentUser?.type || (action?.type === 'SET_USER' && action?.payload?.type) || 'GUEST'; // GUEST is the userType before login
  const accessLevels = state?.currentUser?.accessLevels || (action?.type === 'SET_USER' && action?.payload?.accessLevels) || [];
  const availableReducers = getAvailableReducers(userType, accessLevels);
  if (action.type === 'USER_LOGOUT') {
    return combineReducers(getAvailableReducers('GUEST'))(undefined, action);
  }
  return combineReducers(availableReducers)(state, action);
};

export default rootReducer;
